export default {
    "name": "UpdateRegisteredCar",
    "kind": "HoudiniMutation",
    "hash": "88235b22ea276d2c68b974a15ba93ec9535c0c0b3caa11abd2be90f94a327711",

    "raw": `mutation UpdateRegisteredCar($input: UpdateRegisteredCarInput!) {
  updateRegisteredCar(input: $input) {
    profile
    name
    email
    carId
  }
}`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateRegisteredCar": {
                "type": "User",
                "keyRaw": "updateRegisteredCar(input: $input)",

                "selection": {
                    "fields": {
                        "profile": {
                            "type": "String",
                            "keyRaw": "profile",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        },

                        "email": {
                            "type": "String",
                            "keyRaw": "email",
                            "visible": true
                        },

                        "carId": {
                            "type": "String",
                            "keyRaw": "carId",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "UpdateRegisteredCarInput"
        },

        "types": {
            "UpdateRegisteredCarInput": {
                "carId": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=afc55323daa2ec6f42fb130079295b9e703c61541c25a884f49baa64f722d7fa";